import { Container } from "@mui/material";
import CircleLoader from "components/atoms/CircleLoader";

export default function Billing() {


  return (
    <Container maxWidth="lg">
      <CircleLoader/>
    </Container>
  );
}
